import React from 'react';
import EditableField from 'src/components/fields/EditableField';
import { Select } from 'antd';

const { Option } = Select;

export interface ComboboxEditableFieldProps {
  value: string;
  options: { label: string; value: string }[];
  placeholder?: string;
  className?: string;
  onEditModeChange?: (e: boolean) => void;
  onSelect?: (e: string) => void;
}

const SelectEditableField: React.FC<ComboboxEditableFieldProps> = (props: ComboboxEditableFieldProps) => {
  const { value, onSelect, onEditModeChange, className, placeholder, options } = props;
  return (
    <EditableField
      value={options.find(o => o.value === value)?.label || '-'}
      onEditModeChange={onEditModeChange}
      className={className}
    >
      <Select
        placeholder={placeholder}
        value={value}
        onSelect={(e: string) => onSelect && onSelect(e)}
        style={{ width: '100%' }}
        defaultOpen
        autoFocus
      >
        {options.map(l => (
          <Option key={l.label} value={l.value}>
            {l.label}
          </Option>
        ))}
      </Select>
    </EditableField>
  );
};

export default SelectEditableField;
